/**
 * The create's `warnings` (what the note did not do that the keyer should know, in Thai — e.g. no
 * goods went back into stock because the buyer has no shop code) ride along to the detail page
 * in the navigation state.
 */
export interface CreatedNoteState {
  warnings: string[];
}

export const createdNoteState = (warnings: string[] | undefined): CreatedNoteState => ({
  warnings: warnings ?? [],
});

/** The warnings in a navigation state; none when the page was opened any other way. */
export const createdNoteWarnings = (state: unknown): string[] => {
  if (typeof state !== "object" || state === null || !("warnings" in state)) return [];
  const { warnings } = state;
  if (!Array.isArray(warnings)) return [];
  return warnings.filter((warning): warning is string => typeof warning === "string");
};
